export default "__VITE_ASSET__BJzV7o0m__"